import React, { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";
import { api, BRAND, formatApiError } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/Common";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { EvaluationCompare } from "@/components/EvaluationCompare";

export default function MyEvaluations() {
  const { user } = useAuth();
  const [evals, setEvals] = useState([]);

  useEffect(() => {
    if (!user?.student_id) return;
    api.get(`/evaluations/student/${user.student_id}`).then(r => setEvals(r.data))
      .catch(err => toast.error(formatApiError(err)));
  }, [user]);

  return (
    <div data-testid="student-evaluations-page">
      <PageHeader eyebrow="Desempenho" title="Minhas avaliações" subtitle="Veja sua evolução técnica item por item." mascot={BRAND.MANGUITO_SAQUE} />

      {evals.length === 0 ? (
        <EmptyState title="Nenhuma avaliação ainda" description="Aguarde o professor registrar sua primeira avaliação técnica." mascot={BRAND.MANGUITO} />
      ) : (
        <Tabs defaultValue="history">
          <TabsList>
            <TabsTrigger value="history" data-testid="tab-history">Histórico</TabsTrigger>
            <TabsTrigger value="compare" data-testid="tab-compare">Comparar</TabsTrigger>
          </TabsList>

          <TabsContent value="history">
            <div className="space-y-3">
              {[...evals].reverse().map((e) => {
                const scores = Object.entries(e.scores || {});
                const avg = scores.length ? (scores.reduce((a, [, v]) => a + v, 0) / scores.length).toFixed(1) : "—";
                return (
                  <div key={e.id} className="vv-card p-5">
                    <div className="flex items-center justify-between">
                      <div>
                        <div className="font-black text-lg">{e.date}</div>
                        {e.notes && <div className="text-sm text-muted-foreground mt-1">{e.notes}</div>}
                      </div>
                      <div className="text-right">
                        <div className="text-xs uppercase text-muted-foreground">Média</div>
                        <div className="text-3xl font-black text-[hsl(var(--vv-lime))]">{avg}</div>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 mt-4">
                      {scores.map(([k, v]) => (
                        <div key={k} className="flex items-center justify-between bg-muted/40 rounded px-2.5 py-1.5 text-sm">
                          <span className="text-muted-foreground">{k}</span>
                          <span className="font-black text-[hsl(var(--vv-yellow))]">{v}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </TabsContent>

          <TabsContent value="compare">
            <EvaluationCompare evaluations={evals} />
          </TabsContent>
        </Tabs>
      )}
    </div>
  );
}
